import { selectLibraryResearchItemBalancingInfo } from "../balancingSelectors/selectBalancingLibraryImprovements";
import { selectBalancingOutskirtUnlockLevel } from "../balancingSelectors/selectBalancingOutskirts";
import { selectResourceInfo } from "../balancingSelectors/selectBalancingResources";
import { selectLibraryResearches } from "../balancingSelectors/selectBalancingUiDefinitions";
import { IdOutskirtBuildings } from "../constants/IdOutskirtBuildings";
import { getResourceIcon } from "../features/generic/icon/getResourceIcon";
import { utilImprovements } from "../utils/utilImprovements";
import { selectOutskirtBuildingImprovementInfo, selectOutskirtBuildingInfo, } from "./selectOutskirtBuildingInfo";
import { selectPlayerLevel } from "./selectPlayerLevelInfo";
export var selectLibraryInfo = function (state) {
    return selectOutskirtBuildingInfo(state, IdOutskirtBuildings.Library);
};
export var selectIsQualifiedForLibrary = function (state) {
    var level = selectPlayerLevel(state);
    return level >= selectBalancingOutskirtUnlockLevel(IdOutskirtBuildings.Library);
};
export var selectLibraryResearchItemsInfo = function (state) {
    var libraryResearchItems = selectLibraryResearches();
    return libraryResearchItems.map(function (researchItem) {
        var researchItemBalancingInfo = selectLibraryResearchItemBalancingInfo(researchItem);
        var resource = selectResourceInfo(researchItemBalancingInfo.resourceId);
        var icon = getResourceIcon(resource);
        var improvement = selectOutskirtBuildingImprovementInfo(state, IdOutskirtBuildings.Library, researchItem);
        var level = improvement ? improvement.level : 0;
        var currentBonus = utilImprovements.selectBuffFromImprovementType(researchItemBalancingInfo, level - 1);
        var nextBonus = utilImprovements.selectBuffFromImprovementType(researchItemBalancingInfo, level);
        return {
            balancing: researchItemBalancingInfo,
            currentBonus: currentBonus,
            icon: icon,
            level: level,
            locaKey: resource.locaKey,
            nextBonus: nextBonus,
            resource: resource,
        };
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectLibraryInfo.ts
// module id = 576
// module chunks = 3